// There is theoretical support to use @extends after a typedef, but vs code doesn't support it
// Like it pops up in the autocomplete, but the type intelisense doesn't pick it up

/**
 * @typedef GenericModalProps
 * @property {() => void} closeModal
 */

/**
 * @typedef UnsavedNotesModalProps
 * @property {() => void} saveChanges
 * @property {() => void} ignoreChanges
 * @property {boolean} disabled
**/

/**
* @param {UnsavedNotesModalProps & GenericModalProps} props
**/
export const UnsavedNotesModal = (props) => {

    return <div className='modal-backdrop' onClick={() => !props.disabled && props.closeModal()}>
        <div className='modal unsaved' onClick={e => e.stopPropagation()}>
            <div className='modal-header'>
                <div className='title'>Unsaved Notes</div>
                <button onClick={() => props.closeModal()} disabled={props.disabled} className="close-cross" aria-label="close modal" />
            </div>
            <div className='modal-body'>
                <p>Are you sure you want to close all of your notes?</p>
                <label>You have unsaved notes, marked with a red asterisk <span className='red'>*</span>.</label>
                <div className="inline-list">
                    <button className="button primary" disabled={props.disabled} onClick={() => props.saveChanges()}>Save Notes</button>
                    <button className="button danger" disabled={props.disabled} onClick={() => props.ignoreChanges()}>Ignore Changes</button>
                    <button className="button secondary" disabled={props.disabled} onClick={() => props.closeModal()}>Continue Editing</button>
                </div>
            </div>
        </div>
    </div>
}

/**
* @param {GenericModalProps} props
**/
export const CsvHelpModal = (props) => <div className='modal-backdrop' onClick={() => props.closeModal()}>
    <div className='modal csv-help' onClick={e => e.stopPropagation()}>
        <div className='modal-header'>
            <div className='title'>CSV Help</div>
            <button onClick={() => props.closeModal()} className="close-cross" aria-label="close modal" />
        </div>
        <div className='modal-body'>
            <p>If you have selected 'All Events' or 'X last events', then these events will be downloaded in a separate .csv file.</p>
            <p>Amendment text is not included in .csv file downloads.</p>
            <p>Some text selections in the .csv file may include HTML markup.</p>
        </div>
    </div>
</div>;

